"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextPosition = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TextPosition = ({
  value,
  onClick,
  isActive
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onKeyDown = (0, _react.useCallback)(event => {
    if (event.key === 'Enter') {
      onClick(value);
    }
  }, [onClick, value]);
  const onClickInternal = (0, _react.useCallback)(() => {
    onClick(value);
  }, [onClick, value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.TEXT_POSITION),
    isActive: isActive,
    tabIndex: 0,
    "aria-label": value.label,
    role: "button",
    onClick: onClickInternal,
    onKeyDown: onKeyDown,
    children: value.image
  });
};
exports.TextPosition = TextPosition;
